import React, { useContext } from 'react'

export interface ButtonStatContextValue {
  totalUsers: number
  showButtonStats: boolean
}

const DefaultValue: ButtonStatContextValue = {
  totalUsers: 0,
  showButtonStats: false,
}

const ButtonStatContext = React.createContext<ButtonStatContextValue>(DefaultValue)

export const ButtonStatContextProvider = ButtonStatContext.Provider

/**
 * Creates context that disables showing CTR on buttons
 */
export const NoButtonStatContextProvider = ({ children }: { children?: React.ReactNode }) => (
  <ButtonStatContextProvider value={DefaultValue}>{children}</ButtonStatContextProvider>
)

export const useButtonStatContext = () => {
  return useContext(ButtonStatContext)
}
